import { Td } from '@skytech/ui/Table/Td'
import CellphoneIcon from 'mdi-react/CellphoneIcon'
import HeadphonesIcon from 'mdi-react/HeadphonesIcon'
import HelpIcon from 'mdi-react/HelpIcon'
import { useSelector } from 'react-redux'

import Highlight from '@/components/util/Highlight'
import { getTextFilter } from '@/ducks/devicePolicyReducer'

import DevicePolicyPriceInput from './DevicePolicyPriceInput'

import './device-policy-price-list-item.scss'
// @ts-ignore
const typeToIcon = type => {
  switch (type) {
    case 'MOBILE_PHONE':
      return CellphoneIcon
    case 'MOBILE_PHONE_ACCESSORY':
      return HeadphonesIcon
    default:
      return HelpIcon
  }
}
// @ts-ignore
const DevicePolicyPriceListItem = props => {
  const { id, price, customerName, policyName, type, model, currency } = props

  const textFilter = useSelector(getTextFilter)

  const Icon = typeToIcon(type)

  return (
    <tr className="device-policy-price-list-item">
      <Td>
        <Description {...props} />
      </Td>

      <Td>
        <div className="customer-name">
          <Highlight pattern={textFilter} text={customerName} />
        </div>

        <div>
          <Highlight pattern={textFilter} text={policyName} />
        </div>
      </Td>

      <Td>
        <Icon /> <Highlight pattern={textFilter} text={model} />
      </Td>

      <Td>
        <DevicePolicyPriceInput value={price} id={id} currency={currency} />
      </Td>
    </tr>
  )
}

const Description = ({ model, type, customerName, policyName }: any) => {
  const textFilter = useSelector(getTextFilter)

  const Icon = typeToIcon(type)

  return (
    <>
      <div className="policy">
        {customerName} - {policyName}
      </div>

      <div className="product">
        <Icon /> <Highlight pattern={textFilter} text={model} />
      </div>
    </>
  )
}

export default DevicePolicyPriceListItem
